import { addMemberWatchlistFilm, addWarningNotification, removeMemberWatchlistFilm } from '@vista/omnichannel-components-domain';
import { debounce } from 'debounce';
import { getFailedToAddFilmNotificationDetails, getFailedToRemoveFilmNotificationDetails } from './notifications';
const actionDebounce = 166; // watchlist addition/removal debounce interval (milliseconds)
export const toggleFilmInWatchlist = debounce(async (film, events, displayText, isFilmInWatchlist, i18n) => {
    if (isFilmInWatchlist) {
        await removeFilmFromWatchlist(film, events, displayText, i18n);
    }
    else {
        await addFilmToWatchlist(film, events, displayText, i18n);
    }
}, actionDebounce, true);
const addFilmToWatchlist = async (film, events, displayText, i18n) => {
    var _a;
    try {
        await addMemberWatchlistFilm(film.id);
        (_a = events.onFilmAddedToWatchlist) === null || _a === void 0 ? void 0 : _a.call(events, film);
    }
    catch (_b) {
        // if a callback has been provided for watchlist addition failure, don't trigger the default notification behaviour
        // used in the demo site to force member sign-in when attempting to watchlist a film - no notification is needed
        if (events.onAddFilmToWatchlistFailed) {
            events.onAddFilmToWatchlistFailed(film);
            return;
        }
        const notificationDetails = getFailedToAddFilmNotificationDetails(film, displayText, i18n);
        addWarningNotification(notificationDetails);
    }
};
const removeFilmFromWatchlist = async (film, events, displayText, i18n) => {
    var _a;
    try {
        await removeMemberWatchlistFilm(film.id);
        (_a = events.onFilmRemovedFromWatchlist) === null || _a === void 0 ? void 0 : _a.call(events, film);
    }
    catch (_b) {
        const notificationDetails = getFailedToRemoveFilmNotificationDetails(film, displayText, i18n);
        addWarningNotification(notificationDetails);
    }
};
